// If query param is present in URL, this can be used to toggle logging
import { getFeatureStatus } from '../config';
import { UNLEASH_FEATURE_NAMES } from '../../shared/unleash/feature-names';

export function hasDisplayAdsDebugQuery() {
    try {
        const queryParams: any = new Proxy(
            new URLSearchParams(window.location.search),
            {
                get: (searchParams, prop) => searchParams.get(prop as string),
            },
        );

        return queryParams.displayads_debug;
    } catch (e) {
        return false;
    }
}

const debuggerEnabled = getFeatureStatus(
    UNLEASH_FEATURE_NAMES.enableDisplayAdsDebugger,
);

export function displayAdsLog(log: any, ...optionalParams: any[]) {
    if (debuggerEnabled && hasDisplayAdsDebugQuery()) {
        console.warn(
            'displayads-podlet-horseshoe:   ' + JSON.stringify(log),
            optionalParams,
        );
    }
}
